import { Service } from '@angular/core';

/**
 * Portal-scoped context for widget click beacons, set once per portal load. Kept separate from
 * `FlexiblePortalService` so the click directive on presentational widgets reads it without pulling
 * in the data-fetching service graph.
 */
@Service()
export class FlexiblePortalClickContextService {
  portalUuid = '';
}
